import { instanceToPlain, plainToInstance } from 'class-transformer';
import * as fs from 'fs';
export class BaseSchema
{
    static checkRepeated<T>(parent_name: string, item_name: string, items: T[], getTag: (t: T) => string, getName: (t: T) => string)
    {
        let tag_names: { [tag: string]: string[] } = {};
        items.forEach(c =>
        {
            let tag = getTag(c);
            let name = getName(c);
            if (!tag_names[tag])
                tag_names[tag] = [];
            if (tag_names[tag].includes(name))
            {
                let message = [parent_name, tag, "has repeated", item_name, name];
                message = message.filter(m => m);
                throw new Error(message.join(" "));
            }
            tag_names[tag].push(name);
        });
    }
    tags: { [key: string]: string } = {};
    static byJson(Class: any, json: any): any
    {
        return plainToInstance(Class, json);
    }
    static byText<T extends BaseSchema>(Class: any, text: any): T
    {
        return BaseSchema.byJson(Class, JSON.parse(text));
    }
    static byFile<T extends BaseSchema>(Class: any, path: string): T
    {
        let text = fs.readFileSync(path, { encoding: "utf-8" });
        return BaseSchema.byText(Class, text);
    }
    toJson(): any
    {
        return instanceToPlain(this);
    }
    toText(): string
    {
        return JSON.stringify(this.toJson());
    }
    toFile(path: string)
    {
        fs.writeFileSync(path, this.toText(), { encoding: "utf-8" });
    }
    check(): void
    {
    }
}